import template from "./notices-modal.html";
import "./notices-modal.less";
import { isTextMarkdown } from "../../notices/isTextMarkdown";
import marked from "marked";

export function controller(
	$logger,
	noticeService,
	loadingService,
	$sce
) {
	const ctrl = this;

	ctrl.$onInit = onInit;

	function onInit() {
		ctrl.hasUnreadNotices = noticeService.hasUnreadNotices;
		parseNoticeMarkdown();
	}

	ctrl.onChanges = () => {
		parseNoticeMarkdown();
	};

	ctrl.getSeverityIcon = (notice) => {
		switch(notice.Severity.Code) {
			case "INFO":
				return "zmdi-info notice-info";
				
			case "WARNING":
				return "zmdi-alert-triangle notice-warning";
					
			case "CRITICAL":
				return "zmdi-alert-octagon notice-critical";
					
			default: 
				return "";
		}
	};
	
	ctrl.markRead = (notice) => {
		const thisNotice = noticeService.notices.find(n => n.Id === notice.Id);
		if(thisNotice.Read !== undefined) {
			return;
		}

		const reading = noticeService.readNotice(notice.Id)
			.then(() => {
				ctrl.hasUnreadNotices = noticeService.hasUnreadNotices;
				parseNoticeMarkdown();
			});

		loadingService.watch(reading);
	};

	ctrl.handleClose = () => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.markAllRead = () => {
		if(!noticeService.notices.some(n => n.Read === undefined)) {
			return;
		}

		const readingNotices = noticeService.readAllNotices().then(() => {
			ctrl.hasUnreadNotices = noticeService.hasUnreadNotices;
			parseNoticeMarkdown();
		});

		loadingService.watch(readingNotices);
	};

	function parseNoticeMarkdown() {
		ctrl.parsedNotices = noticeService.notices.map(n => {
			if(n.Content && isTextMarkdown(n.Content)) {
				return {
					...n,
					Content: $sce.trustAsHtml(marked(n.Content))
				};
			}
			return { 
				...n,
				Content: $sce.trustAsHtml(n.Content) 
			};
		});
	}
}

export default angular
	.module("vesl.components.notices-modal", [])
	.component("noticesModal", {
		template,
		controller,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
